import { ApiError } from '@/lib/http/http-api';
import { t } from '@/lib/i18n';

const authErrorMessages: Record<string, string> = {
  SMS_PASSWORD_RESET_DISABLED: t('短信找回密码未启用，请联系管理员'),
  SMS_LOGIN_DISABLED: t('短信登录未启用，请联系管理员'),
  SMS_RATE_LIMITED: t('短信发送过于频繁，请稍后重试'),
  SMS_SEND_FAILED: t('短信发送失败，请稍后重试'),
  INVALID_PHONE_NUMBER: t('请输入大陆手机号'),
  PHONE_NOT_BOUND: t('该手机号未注册或未绑定'),
  PHONE_BINDING_REQUIRED: t('请先在安全设置中绑定手机号'),
  PHONE_NUMBER_EXIST: t('手机号已被其他账号绑定'),
  OTP_NOT_FOUND: t('验证码无效或已使用，请重新获取'),
  OTP_EXPIRED: t('验证码已过期，请重新获取'),
  INVALID_OTP: t('验证码错误'),
  TOO_MANY_ATTEMPTS: t('尝试次数过多，请重新获取验证码'),
  SESSION_NOT_FRESH: t('为保护账号，请退出并重新登录后再管理设备'),
  INVALID_EMAIL_OR_PASSWORD: t('邮箱或密码错误'),
  INVALID_USERNAME_OR_PASSWORD: t('用户名或密码错误'),
  INVALID_PASSWORD: t('密码错误'),
  INVALID_EMAIL: t('邮箱格式不正确'),
  EMAIL_NOT_VERIFIED: t('请先验证邮箱'),
  EMAIL_ALREADY_VERIFIED: t('邮箱已验证'),
  USER_NOT_FOUND: t('用户不存在'),
  INVALID_USER: t('用户无效'),
  USER_ALREADY_EXISTS: t('用户已存在'),
  USER_ALREADY_EXISTS_USE_ANOTHER_EMAIL: t('用户已存在，请使用其他邮箱'),
  USERNAME_IS_ALREADY_TAKEN: t('用户名已被使用'),
  USERNAME_TOO_SHORT: t('用户名过短'),
  USERNAME_TOO_LONG: t('用户名过长'),
  INVALID_USERNAME: t('用户名格式不正确'),
  INVALID_DISPLAY_USERNAME: t('显示用户名格式不正确'),
  USERNAME_IS_IMMUTABLE: t('用户名不可修改'),
  PASSWORD_TOO_SHORT: t('密码过短'),
  PASSWORD_TOO_LONG: t('密码过长'),
  PASSWORD_POLICY: t('密码须包含字母和数字'),
  PASSWORD_ALREADY_SET: t('此账号已设置密码'),
  USER_ALREADY_HAS_PASSWORD: t('此账号已设置密码，请提供密码以删除账号'),
  INVALID_TOKEN: t('令牌无效或已过期，请重新生成'),
  TOKEN_EXPIRED: t('令牌无效或已过期，请重新生成'),
  INVALID_SESSION_TOKEN: t('会话无效，请重新登录'),
  SESSION_EXPIRED: t('会话已过期，请重新登录'),
  AUTHENTICATION_REQUIRED: t('请先登录'),
  BANNED_USER: t('账号已被封禁，请联系管理员'),
  INVALID_CODE: t('验证码错误'),
  INVALID_BACKUP_CODE: t('备用码无效或已被使用'),
  INVALID_TWO_FACTOR_COOKIE: t('两步验证会话已失效，请重新登录'),
  OTP_HAS_EXPIRED: t('验证码已过期，请重新获取'),
  OTP_NOT_ENABLED: t('尚未开启一次性验证码'),
  OTP_NOT_CONFIGURED: t('一次性验证码暂不可用'),
  TOTP_NOT_ENABLED: t('尚未开启认证器验证'),
  TOTP_ALREADY_ENABLED: t('认证器验证已开启'),
  TOTP_NOT_CONFIGURED: t('认证器验证暂不可用'),
  TWO_FACTOR_NOT_ENABLED: t('尚未开启两步验证'),
  BACKUP_CODES_NOT_ENABLED: t('尚未启用备用码'),
  TOO_MANY_ATTEMPTS_REQUEST_NEW_CODE: t('尝试次数过多，请重新获取验证码'),
  ACCOUNT_TEMPORARILY_LOCKED: t('验证失败次数过多，账号已暂时锁定，请稍后重试'),
  TOO_MANY_REQUESTS: t('请求过于频繁，请稍后重试'),
  VERIFICATION_FAILED: t('人机验证失败，请重试'),
  MISSING_RESPONSE: t('请先完成人机验证'),
  SERVICE_UNAVAILABLE: t('安全验证暂不可用'),
  MISSING_SECRET_KEY: t('验证码配置不完整，请联系管理员'),
  INVALID_DEVICE_CODE: t('设备授权码无效'),
  INVALID_USER_CODE: t('设备授权码无效'),
  EXPIRED_DEVICE_CODE: t('设备授权码已过期'),
  EXPIRED_USER_CODE: t('设备授权码已过期'),
  AUTHORIZATION_PENDING: t('正在等待设备授权'),
  ACCESS_DENIED: t('无访问权限'),
  DEVICE_CODE_ALREADY_PROCESSED: t('此设备授权请求已处理'),
  DEVICE_CODE_NOT_CLAIMED: t('请先查看设备授权请求'),
  INVALID_DEVICE_CODE_STATUS: t('设备授权请求状态无效'),
  POLLING_TOO_FREQUENTLY: t('请求过于频繁，请稍后重试'),
  INVALID_REQUEST: t('请求格式不正确'),
  INVALID_CLIENT: t('客户端无效'),
  INVALID_GRANT: t('授权无效或已过期'),
  EXPIRED_TOKEN: t('令牌无效或已过期，请重新生成'),
  SLOW_DOWN: t('请求过于频繁，请稍后重试'),
  SERVER_ERROR: t('认证服务异常，请稍后重试'),
  UNSUPPORTED_GRANT_TYPE: t('不支持此授权类型'),
  FAILED_TO_CREATE_USER: t('创建账号失败，请重试'),
  FAILED_TO_UPDATE_USER: t('更新账号失败，请重试'),
  FAILED_TO_CREATE_SESSION: t('创建登录会话失败，请重试'),
  FAILED_TO_GET_SESSION: t('获取登录会话失败，请重试'),
  FAILED_TO_GET_USER_INFO: t('获取用户信息失败，请重试'),
  USER_EMAIL_NOT_FOUND: t('未获取到账号邮箱'),
  SOCIAL_ACCOUNT_ALREADY_LINKED: t('该第三方账号已关联'),
  LINKED_ACCOUNT_ALREADY_EXISTS: t('该第三方账号已关联'),
  PROVIDER_NOT_FOUND: t('此登录方式暂不可用'),
  CREDENTIAL_ACCOUNT_NOT_FOUND: t('未找到密码登录凭据'),
  ACCOUNT_NOT_FOUND: t('账号不存在'),
  EMAIL_CAN_NOT_BE_UPDATED: t('邮箱不可修改'),
  CHANGE_EMAIL_DISABLED: t('暂不允许修改邮箱'),
  EMAIL_MISMATCH: t('邮箱不匹配'),
  VERIFICATION_EMAIL_NOT_ENABLED: t('邮箱验证暂不可用'),
  FAILED_TO_CREATE_VERIFICATION: t('创建验证请求失败，请重试'),
  FAILED_TO_UNLINK_LAST_ACCOUNT: t('不能解除最后一个登录账号的关联'),
  VALIDATION_ERROR: t('请检查填写的信息'),
  MISSING_FIELD: t('请填写必填信息'),
  FIELD_NOT_ALLOWED: t('不允许修改此字段'),
  ID_TOKEN_NOT_SUPPORTED: t('此登录方式暂不可用'),
  INVALID_ORIGIN: t('请求来源无效，请从本站重新登录'),
  MISSING_OR_NULL_ORIGIN: t('请求来源无效，请从本站重新登录'),
  CROSS_SITE_NAVIGATION_LOGIN_BLOCKED: t('请求来源无效，请从本站重新登录'),
  INVALID_CALLBACK_URL: t('登录跳转地址无效'),
  INVALID_REDIRECT_URL: t('登录跳转地址无效'),
  INVALID_ERROR_CALLBACK_URL: t('登录跳转地址无效'),
  INVALID_NEW_USER_CALLBACK_URL: t('登录跳转地址无效'),
  CALLBACK_URL_REQUIRED: t('缺少登录跳转地址'),
  ASYNC_VALIDATION_NOT_SUPPORTED: t('认证配置不正确，请联系管理员'),
  METHOD_NOT_ALLOWED_DEFER_SESSION_REQUIRED: t('认证配置不正确，请联系管理员'),
  BODY_MUST_BE_AN_OBJECT: t('请求格式不正确'),
  YOU_CANNOT_BAN_YOURSELF: t('不能封禁自己的账号'),
  YOU_CANNOT_REMOVE_YOURSELF: t('不能删除自己的账号'),
  YOU_CANNOT_IMPERSONATE_ADMINS: t('不能冒充管理员'),
  INVALID_ROLE_TYPE: t('角色类型无效'),
  NO_DATA_TO_UPDATE: t('没有需要更新的数据'),
  PASSWORD_CANNOT_BE_UPDATED_VIA_UPDATE_USER: t('请使用专用的密码设置操作'),
  YOU_HAVE_REACHED_THE_MAXIMUM_NUMBER_OF_ORGANIZATIONS: t('已达到租户数量上限'),
  ORGANIZATION_ALREADY_EXISTS: t('租户已存在'),
  ORGANIZATION_SLUG_ALREADY_TAKEN: t('租户标识已被使用'),
  ORGANIZATION_NOT_FOUND: t('租户不存在'),
  USER_IS_NOT_A_MEMBER_OF_THE_ORGANIZATION: t('用户不属于此租户'),
  YOU_ARE_NOT_A_MEMBER_OF_THIS_ORGANIZATION: t('你不属于此租户'),
  NO_ACTIVE_ORGANIZATION: t('请先选择租户'),
  USER_IS_ALREADY_A_MEMBER_OF_THIS_ORGANIZATION: t('用户已是此租户成员'),
  MEMBER_NOT_FOUND: t('成员不存在'),
  ROLE_NOT_FOUND: t('角色不存在'),
  TEAM_ALREADY_EXISTS: t('团队已存在'),
  TEAM_NOT_FOUND: t('团队不存在'),
  YOU_CANNOT_LEAVE_THE_ORGANIZATION_AS_THE_ONLY_OWNER:
    t('请先转移所有权，再退出租户'),
  YOU_CANNOT_LEAVE_THE_ORGANIZATION_WITHOUT_AN_OWNER:
    t('请先转移所有权，再退出租户'),
  USER_IS_ALREADY_INVITED_TO_THIS_ORGANIZATION: t('已邀请该用户加入此租户'),
  INVITATION_NOT_FOUND: t('邀请不存在或已失效'),
  YOU_ARE_NOT_THE_RECIPIENT_OF_THE_INVITATION: t('此邀请不属于当前账号'),
  EMAIL_VERIFICATION_REQUIRED_BEFORE_ACCEPTING_OR_REJECTING_INVITATION:
    t('请先验证邮箱'),
  EMAIL_VERIFICATION_REQUIRED_FOR_INVITATION: t('请先验证邮箱'),
  INVITER_IS_NO_LONGER_A_MEMBER_OF_THE_ORGANIZATION: t('邀请人已离开此租户'),
  FAILED_TO_RETRIEVE_INVITATION: t('获取邀请失败，请重试'),
  YOU_HAVE_REACHED_THE_MAXIMUM_NUMBER_OF_TEAMS: t('已达到团队数量上限'),
  UNABLE_TO_REMOVE_LAST_TEAM: t('不能删除最后一个团队'),
  ORGANIZATION_MEMBERSHIP_LIMIT_REACHED: t('已达到租户成员数量上限'),
  INVITATION_LIMIT_REACHED: t('已达到邀请数量上限'),
  TEAM_MEMBER_LIMIT_REACHED: t('已达到团队成员数量上限'),
  USER_IS_NOT_A_MEMBER_OF_THE_TEAM: t('用户不属于此团队'),
  YOU_CAN_NOT_ACCESS_THE_MEMBERS_OF_THIS_TEAM: t('无访问权限'),
  YOU_DO_NOT_HAVE_AN_ACTIVE_TEAM: t('请先选择团队'),
  MISSING_AC_INSTANCE: t('认证配置不正确，请联系管理员'),
  YOU_MUST_BE_IN_AN_ORGANIZATION_TO_CREATE_A_ROLE:
    t('请先加入租户，再创建角色'),
  TOO_MANY_ROLES: t('已达到角色数量上限'),
  INVALID_RESOURCE: t('权限包含无效资源'),
  ROLE_NAME_IS_ALREADY_TAKEN: t('角色名称已被使用'),
  CANNOT_DELETE_A_PRE_DEFINED_ROLE: t('不能删除预定义角色'),
  ROLE_IS_ASSIGNED_TO_MEMBERS: t('请先为成员分配其他角色，再删除此角色'),
  INVALID_TEAM_ID: t('团队编号包含保留字符'),
  UNEXPECTED_ERROR: t('认证请求失败'),
  UNKNOWN_ERROR: t('认证请求失败'),
};

/**
 * Better Auth's client answers `{ data, error }` instead of throwing, and its error type
 * is not the API's envelope. Narrowing it here keeps `ApiError` the only failure shape
 * the UI has to know about.
 *
 * It lives apart from `session.ts` because every auth-related call needs it — password
 * reset, e-mail verification, two-factor, social sign-in — and pulling it from the session
 * module would make those modules depend on the session query for no reason.
 *
 * `status` is `0` when the client could not reach the API at all, which is the same
 * "network failure" class `ApiError` already uses for fetch failures.
 */
export const toAuthError = (error: unknown): ApiError => {
  const candidate = (error ?? {}) as {
    status?: unknown;
    code?: unknown;
    message?: unknown;
    error?: unknown;
    error_description?: unknown;
  };
  const rawCode = candidate.code ?? candidate.error;
  const code =
    typeof rawCode === 'string' && rawCode !== ''
      ? rawCode
      : 'AUTH_REQUEST_FAILED';
  const rawMessage = candidate.message ?? candidate.error_description;
  let message = authErrorMessages[code.toUpperCase()];
  if (!message && code.startsWith('YOU_ARE_NOT_ALLOWED_TO_'))
    message = t('无访问权限');
  if (!message) {
    message = t('认证请求失败');
    if (typeof rawMessage === 'string' && rawMessage !== '') {
      message = t(rawMessage);
    }
  }
  return new ApiError({
    status: typeof candidate.status === 'number' ? candidate.status : 0,
    code,
    message,
  });
};

/**
 * `fetch`'s own rejection (`Failed to fetch`) is not a better-auth error object; wrapping
 * it keeps a thrown value an `ApiError` even when the request never left the browser.
 */
export const toNetworkError = (error: unknown, fallback: string): ApiError =>
  error instanceof ApiError
    ? error
    : new ApiError({
        status: 0,
        code: 'NETWORK_ERROR',
        message: fallback,
      });
